module.exports = __webpack_public_path__ + "img/upc.05410c8e.svg";